if (!customElements.get("swiper-component")) {
  class SwiperComponent extends HTMLElement {
    constructor() {
      super();
      this.swiperInstance = null;
      this.init();
    }

    init() {
      // Wait for Swiper to be available
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.init(), 100);
        return;
      }

      const swiperContainer = this.querySelector('.swiper');
      if (!swiperContainer) return;

      // Get configuration from data attributes
      const enableSlider = this.dataset.enableSlider === 'true';
      const enableMobile = this.dataset.enableMobile === 'true';
      const showNav = this.dataset.showNav === 'true';
      const showDots = this.dataset.showDots === 'true';
      const showScrollbar = this.dataset.showScrollbar === 'true';
      const parseColumns = (val, fallback) => val === 'auto' ? 'auto' : (parseInt(val) || fallback);
      const columns = parseColumns(this.dataset.columns, 4);
      const columnsTablet = parseColumns(this.dataset.columnsTablet, 3);
      const columnsMobile = parseColumns(this.dataset.columnsMobile, 2);

      const gapMap = {
        'none': 0,
        'tiny': 2,
        'double-extra-small': 1,
        'extra-small': 10,
        'small': 20,
        'medium': 48,
        'large': 80,
        'extra-large': 128
      };
      const columnGap = this.dataset.columnGap;
      const gap = gapMap[columnGap] !== undefined ? gapMap[columnGap] : 20;
      const gapMobile = columnGap === 'medium' ? 13 : (columnGap === 'large' || columnGap === 'extra-large') ? Math.round(gap / 2) : gap;

      // Responsive breakpoints configuration
      const breakpoints = {
        320: {
          slidesPerView: columnsMobile,
          spaceBetween: gapMobile,
          enabled: enableMobile
        },
        768: {
          slidesPerView: columnsTablet,
          spaceBetween: gap,
          enabled: enableSlider || enableMobile
        },
        1024: {
          slidesPerView: columns,
          spaceBetween: gap,
          enabled: enableSlider
        }
      };

      // Configure Swiper options
      const config = {
        slidesPerView: columns,
        spaceBetween: gap,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: breakpoints,
        navigation: showNav ? {
          nextEl: this.querySelector('.swiper-button-next'),
          prevEl: this.querySelector('.swiper-button-prev'),
        } : false,
        pagination: showDots ? {
          el: this.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: this.dataset.dynamicBullets !== 'false'
        } : false,
        scrollbar: showScrollbar ? {
          el: this.querySelector('.swiper-scrollbar'),
          draggable: true,
          hide: false
        } : false,
        mousewheel: {
          forceToAxis: true,
          releaseOnEdges: true,
          sensitivity: 1
        },
        on: {
          init: () => {
            this.classList.add('swiper-initialized');
            this.dispatchEvent(new CustomEvent('swiper:init'));
          },
          slideChange: () => {
            this.dispatchEvent(new CustomEvent('swiper:slideChange'));
          }
        }
      };

      // Initialize Swiper
      this.swiperInstance = new Swiper(swiperContainer, config);

      // Handle resize
      window.addEventListener('resize', this.handleResize.bind(this));
    }

    handleResize() {
      if (this.swiperInstance && this.swiperInstance.update) {
        this.swiperInstance.update();
      }
    }

    disconnectedCallback() {
      if (this.swiperInstance && this.swiperInstance.destroy) {
        this.swiperInstance.destroy(true, true);
      }
      window.removeEventListener('resize', this.handleResize.bind(this));
    }
  }

  customElements.define('swiper-component', SwiperComponent);
}